<template>
	<div class="store-info-body">
		<div class="store-info-container">
			<div class="fx-title">
				<p>基础信息
					<span v-if='sourceflag === 1' class="title-span">门店来源：{{datasource}}</span>
					<span  v-if='sourceflag === 1' class="title-span">门店状态：
						<span v-if='mdstopflag === 0' style="color:green">启用</span>
						<span v-if='mdstopflag === 1' style="color:red">停用</span>
					</span>
					<el-button v-if='clddock === 1 && sourceflag === 1' style="margin-left:20px" size='mini' type='primary' plain @click="statusReload">刷新</el-button>
				</p>
			</div>
			<div class='store-picture'>
				<uploadBox
					class="store-img"
					@save='save'
					@getFormData='getFormData'
					@updateImg='updateImg'
					@isFalse='isFalse'
					:imgSrc.sync="ruleForm.imgurl"
					:dataid="shopid"
					:uploadError.sync="uploadError"
					:from='from'
					:editDisable="editDisable"
					ref="bannerUpload"/>
				<div class="img-tips">80*80,1M以内，png/jpg/jpeg格式</div>
			</div>
			<el-form :model="ruleForm" :rules="rules" :inline-message='true' ref="ruleForm" label-width="125px" class="form-box">
				<el-form-item label="店铺名称：" prop="storeName">
					<el-input v-model="ruleForm.storeName" size='mini' :maxlength='20' class="short-input" placeholder="请输入店铺名称" :disabled="!editDisable"></el-input>
					<span v-if='sourceflag === 1' style='color:#ababab;margin-left:20px'>门店名称：{{mdname}}</span>
				</el-form-item>
				<el-form-item label="店铺编号：">
					<span>{{ruleForm.code}}</span><span v-if='sourceflag === 1' style='color:#ababab;margin-left:152px'>门店编号：{{mdcode}}</span>
				</el-form-item>
				<div class="tel-box">
					<el-form-item label="联系电话：" prop="tel" :inline-message='false'>
						<el-input
							v-model="ruleForm.tel"
							size='mini'
							type="number"
							class="short-input"
							oninput="if(value.length>11)value=value.slice(0,11)"
							placeholder="请输入联系人电话"
							:disabled="!editDisable"></el-input>
					</el-form-item>
					<el-form-item prop="otherTel">
						<el-input
							v-model="ruleForm.otherTel"
							size='mini'
							type="number"
							class="short-input"
							oninput="if(value.length>11)value=value.slice(0,11)"
							placeholder="请输入备用电话"
							:disabled="!editDisable"></el-input>
					</el-form-item>
				</div>
				<el-form-item label="联系人：" prop="linkman">
					<el-input
						v-model="ruleForm.linkman"
						size='mini'
						:maxlength='15'
						class="short-input"
						placeholder="请输入联系人"
						:disabled="!editDisable"
						@change="linkmanChange"></el-input>
				</el-form-item>
				<el-form-item label="邮 箱：" prop="email">
					<el-input v-model="ruleForm.email" size='mini' class="short-input" placeholder="请输入邮箱"  :disabled="!editDisable"></el-input>
				</el-form-item>
				<el-form-item label="区 域：" prop='area'>
					<el-select v-model="ruleForm.area" size='mini' class='short-input' placeholder="请选择区域" :disabled="!editDisable" @change='areaChange("ruleForm")'>
						<el-option
							v-for="item in areaList"
							:key="item.code"
							:label="item.name"
							:value="item.code">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="位 置：" prop='postion' ref="postion">
					<el-select v-model="ruleForm.province" size='mini' class='short-input select-input' @change='provinceChange("ruleForm")' placeholder="请选择省份" :disabled="!editDisable">
						<el-option
							v-for="item in provinceList"
							:key="item.id"
							:label="item.name"
							:value="item.id">
						</el-option>
					</el-select>
					<el-select v-model="ruleForm.city" size='mini' class='short-input select-input' @change='cityChange' placeholder="请选择城市" :disabled="!editDisable">
						<el-option
							v-for="item in cityList"
							:key="item.id"
							:label="item.name"
							:value="item.id">
						</el-option>
					</el-select>
					<!-- <el-select v-model="ruleForm.area" size='mini' class='short-input' @change='postionChange("ruleForm")' placeholder="请选择区">
						<el-option
							v-for="item in areaList"
							:key="item.id"
							:label="item.name"
							:value="item.id">
						</el-option>
					</el-select> -->
				</el-form-item>
				<el-form-item label="地 址：" prop='address'>
					<el-input class='long-input' @input="addressInput" :disabled="!editDisable" size='mini' v-model="ruleForm.address" :maxlength='100' placeholder="请输入详细地址" id="searchInput"></el-input>
				</el-form-item>
				<el-form-item label="经营面积：" prop='square'>
					<el-input class='long-input' v-model="ruleForm.square" size='mini' :maxlength='100' placeholder="请输入经营面积" :disabled="!editDisable"></el-input>
				</el-form-item>
				<el-form-item label="备 注：" prop="memo">
					<el-input class='long-input' type="textarea" size='mini' v-model="ruleForm.memo" :rows='3' :maxlength='300' placeholder='300字以内' :disabled="!editDisable"></el-input>
				</el-form-item>
				<!-- <div class="store-setting">
					<div class="fx-title">
						<p>商龙云信息</p>
					</div>
					<el-form-item label="商龙云集团号：">
						<el-input  class='short-input' :disabled="!editDisable" size='mini' v-model="ruleForm.groupcode"></el-input>
					</el-form-item>
					<el-form-item label="商龙云集团名称：">
						<el-input  class='short-input' :disabled="!editDisable" size='mini' v-model="ruleForm.groupname"></el-input>
					</el-form-item>
				</div> -->
				<!-- <div class="time-management">
					<div class="fx-title">
						<p>时间管理</p>
					</div>
					<div class="time-choise">
						<el-form-item label="营业时间：" prop="businessHours" size='mini' class="open-date">
							<el-radio-group v-model="ruleForm.businessHours" @change="businessHoursChange" :disabled="!editDisable">
								<el-radio label="false">全天</el-radio>
								<el-radio label="true">自定义</el-radio>
							</el-radio-group>
						</el-form-item>
						<el-time-picker
							:disabled="customTimeFlag"
							@change="timeChange"
							v-model="ruleForm.startTime"
							class="time-picker-part"
							format='HH:mm'
							value-format="HH:mm"
							size='mini'
							:picker-options="{
								selectableRange:`00:00:00 -${ruleForm.closeTime ? ruleForm.closeTime+':00' : '23:59:00'}`
							}">
						</el-time-picker>
						<span>至</span>
						<el-time-picker
							:disabled="customTimeFlag"
							:clearable="false"
							@change="timeChange"
							v-model="ruleForm.closeTime"
							class="time-picker-part"
							format='HH:mm'
							value-format="HH:mm"
							size='mini'
							:picker-options="{
									selectableRange:`${ruleForm.startTime ? ruleForm.startTime+':00' : '00:00:00'}-23:59:00`
							}">
						</el-time-picker>
					</div>
					<div class="time-choise" v-show="ruleForm.sendtimeflag === 0 && customTimeFlag === false">
						<span style="width:100px">营业时间</span>
						<el-time-picker
							style="width:150px"
							:disabled="!editDisable"
							:clearable="false"
							v-model="ruleForm.samedayDeliveryTime"
							format='HH:mm'
							value-format="HH:mm"
							size='mini'
							:picker-options="{
									selectableRange:`${ruleForm.startTime ? ruleForm.startTime+':00' : '00:00:00'}-${ruleForm.closeTime ? ruleForm.closeTime+':00' : '23:59:59'}`
							}">
						</el-time-picker>
						<span style="width:150px">点前下单，可当日送货</span>
					</div>
					<div class="time-choise" v-show="ruleForm.sendtimeflag === 0 && customTimeFlag === true">
						<span style="width:100px">营业时间</span>
						<el-time-picker
							style="width:150px"
							v-model="ruleForm.samedayDeliveryTime"
							:disabled="!editDisable"
							format='HH:mm'
							value-format="HH:mm"
							size='mini'
							placeholder="任意时间点">
						</el-time-picker>
						<span style="width:150px">点前下单，可当日送货</span>
					</div>
					<div class="delivery-time-box">
						<span>非营业时间单据处理</span>：
						<el-radio-group v-model="ruleForm.nobussinessflag" :disabled="!editDisable">
							<el-radio :label="0">允许客户下单</el-radio>
							<el-radio :label="1">不允许客户下单</el-radio>
						</el-radio-group>
					</div>
					<div class="delivery-time-box">
						<span>送货时间管理</span>：
						<el-radio-group v-model="ruleForm.sendtimeflag" :disabled="!editDisable">
							<el-radio :disabled="takeDeliveryTimeFlag" :label="1">管理送货时间</el-radio>
							<el-radio :label="0">不管理送货时间</el-radio>
						</el-radio-group>
						<span style="width:400px;font-size: 13px" v-if="takeDeliveryTimeFlag">（客户启用了收货时间管理，卖家不能管理送货时间）</span>
					</div>
					<div class="delivery-time-box">
						<span>送达时间（营业内）</span>：在
						<el-input type="number" v-model="ruleForm.arrivaDate" size='mini' class="delivery-time-input" :disabled="!editDisable"/>
						天后的
						<el-time-picker
							:disabled="!editDisable"
							:clearable="false"
							v-model="ruleForm.arrivaTime"
							class="delivery-time-input"
							format='HH:mm'
							value-format="HH:mm"
							size='mini'
							:picker-options="{
								selectableRange:`00:00:00 -23:59:00`
							}">
						</el-time-picker>
						左右送达
					</div>
					<div class="delivery-time-box">
						<span>预计送达时间（非营业内）</span>：在
						<el-input type="number" v-model="ruleForm.planDeliveryDay" size='mini' class="delivery-time-input" :disabled="!editDisable"/>
						天后的
						<el-time-picker
							:disabled="!editDisable"
							:clearable="false"
							v-model="ruleForm.planDeliveryTime"
							class="delivery-time-input"
							format='HH:mm'
							value-format="HH:mm"
							size='mini'
							:picker-options="{
								selectableRange:`00:00:00 -23:59:00`
							}">
						</el-time-picker>
						左右送达
					</div>
				</div> -->
				<div class="store-setting">
					<div class="fx-title">
						<p>店铺设置</p>
					</div>
					<el-form-item label="店铺状态：" prop="storeStatus">
						<el-radio-group v-model="ruleForm.storeStatus" :disabled="!editDisable">
							<el-radio label="false">启用</el-radio>
							<el-radio label="true">停用</el-radio>
						</el-radio-group>
					</el-form-item>
					<div class="open-status">
						<span>营业状态：</span>
						<span>{{ruleForm.shopState}}</span>
					</div>
					<el-form-item label="买家收货地址数量：" prop="addressQuantityType" size='mini' class="open-date address-quantity">
						<el-radio-group v-model="ruleForm.addressQuantityType" @change="addressQuantityChange">
							<el-radio label="false">不限制</el-radio>
							<el-radio label="true">&nbsp;</el-radio>
						</el-radio-group>
						<span v-show="ruleForm.addressQuantityType === 'false'">自定义</span>
						<el-input
							v-show="ruleForm.addressQuantityType === 'true'"
							v-model="ruleForm.addressQuantity"
							size='mini'
							class="short-input"
							@input="inputEvent"
							placeholder="请输入1-100正整数"
							:disabled="!editDisable"></el-input>
							<span style="padding-left: 30px;">注：此功能只针对极速订买家生效</span>
					</el-form-item>
				</div>
			</el-form>
		</div>
		<div class="store-info-btn">
			<el-button class="btn" size='small' plain type="primary" @click="cancel">取消</el-button>
			<el-button class="btn" size='small' type="primary" @click="saveInfo" v-show="true">保存</el-button>
		</div>
	</div>
</template>

<script>
import uploadBox from '@/components/businessCenter/Upload.vue'
import { cityData } from '@/js/location/city.js'
import { provinceData } from '@/js/location/province.js'
import { geography } from '@/js/location/geography.js'
// import { areaData } from '@/js/location/area.js'
let _AMap = null
export default {
	name: 'storeInfo',
	components: {
		uploadBox
	},
	data () {
		var postion = (rule, value, callback) => {
			if (this.isTrue === true) {
				return callback(new Error('请选择城市'))
			} else {
				callback()
			}
		}
		var area = (rule, value, callback) => {
			if (this.waringArea === true) {
				return callback(new Error('请选择区域'))
			} else {
				callback()
			}
		}
		return {
			paymode: 2,
			// takeDeliveryTimeFlag: false,
			datasource: '',
			mdname: '',
			matchid: '',
			mdcode: '',
			mdstopflag: null,
			clddock: null,
			sourceflag: null,
			imgData: {},
			shopid: '',
			from: 'store',
			uploadError: false,
			phoneReg: /^(((13[0-9]{1})|(14[0-9]{1})|(15[0-9]{1})|(16[0-9]{1})|(17[0-9]{1})|(18[0-9]{1})|(19[0-9]{1}))+\d{8})$/,
			linkmanReg: /[^a-zA-Z0-9\u4e00-\u9fa5]/g,
			provinceListTotal: [],
			provinceList: [],
			cityList: [],
			areaList: [],
			isTrue: true,
			// customTimeFlag: true,
			locationLng: '',
			locationLat: '',
			waringArea: true,
			ruleForm: {
				// groupcode: '',
				// groupname: '',
				// samedayDeliveryTime: '',
				// nobussinessflag: 0,
				// sendtimeflag: 0,
				imgurl: '',
				name: '',
				storeName: '',
				code: '',
				tel: '',
				otherTel: '',
				linkman: '',
				email: '',
				area: '',
				province: '',
				city: '',
				address: '',
				square: '',
				memo: '',
				addressQuantityType: 'false',
				addressQuantity: '',
				// businessHours: 'false',
				// startTime: '00:00',
				// closeTime: '23:59',
				// arrivaDate: '0',
				// arrivaTime: '23:59',
				// planDeliveryDay: '1',
				// planDeliveryTime: '23:59',
				storeStatus: 'false',
				shopState: '未营业'
			},
			rules: {
				storeName: [
					{ required: true, message: '请输入店铺名称', trigger: 'blur' }
				],
				addressQuantityType: [
					{ required: true }
				],
				tel: [
					{
						required: true,
						validator: (rule, value, callback) => {
							if (value === '') {
								callback(new Error('请输入联系人电话'))
							} else if (!this.phoneReg.test(value)) {
								callback(new Error('手机号码格式不正确，请重新输入！'))
							} else {
								callback()
							}
						},
						trigger: 'blur'
					}
				],
				otherTel: [
					{
						validator: (rule, value, callback) => {
							if (value && !this.phoneReg.test(value)) {
								callback(new Error('手机号码格式不正确，请重新输入！'))
							} else {
								callback()
							}
						},
						trigger: 'blur'
					}
				],
				linkman: [
					{ required: true, message: '请输入联系人', trigger: 'blur' }
				],
				email: [
					{ type: 'email', required: true, message: '请输入邮箱', trigger: 'blur' }
				],
				area: [
					{ required: true, validator: area, trigger: 'blur' }
				],
				postion: [
					{ required: true, validator: postion, trigger: 'blur' }
				],
				address: [
					{
						required: true,
						validator: (rule, value, callback) => {
							if (value === '') {
								callback(new Error('请输入详细地址'))
							} else {
								callback()
							}
						},
						trigger: 'change'
					}
				],
				// businessHours: [
				// 	{ required: true }
				// ],
				storeStatus: [
					{ required: true }
				]
			},
			editDisable: true,
			storeInfoFlag: false,
			type: ''
		}
	},
	created () {
		this.getAuthority('01_0001_0000_00')
	},
	mounted () {
		this.provinceListTotal = provinceData.RECORDS
		this.areaList = geography
		this.sessionStoreId = sessionStorage.getItem('storeid')
		if (this.sessionStoreId) {
			this.shopid = this.sessionStoreId
			// this.load().then((data) => {
			this.getDetailPost()
			// })
		} else {
			// this.load()
			let storeInfoFlag = JSON.stringify(this.storeInfoFlag)
			window.sessionStorage.setItem('storeInfoFlag', storeInfoFlag)
		}
	},
	methods: {
		inputEvent () {
			this.ruleForm.addressQuantity = this.ruleForm.addressQuantity.replace(/(^[0]|[^\d])/g, '')
			if (this.ruleForm.addressQuantity > 100) {
				this.ruleForm.addressQuantity = 100
			}
		},
		addressQuantityChange () {
			this.ruleForm.addressQuantity = this.ruleForm.addressQuantityType === 'true' ? this.ruleForm.addressQuantity : ''
		},
		// timeChange () {
		// 	this.ruleForm.samedayDeliveryTime = ''
		// },
		statusReload () {
			let params = {
				matchId: this.matchid
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIV}/shop/dockcld/refreshCldShopStopFlag`,
				data: params
			}).then(res => {
				if (res.result) {
					this.mdstopflag = res.data.mdStopFLag
				} else {
					this.$message.error(res.msg)
				}
			})
		},
		getAuthority (id) {
			let params = {
				pId: id
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlIV}/account/authority/getUserAuthority`,
				data: params
			}).then(res => {
				if (res.result) {
					let a = res.data
					if (a.indexOf('01_0001_0001_00') > -1) {
						this.editDisable = true
					} else {
						if (window.sessionStorage.getItem('isAdd') === 'true') {
							this.editDisable = true
						} else {
							this.editDisable = false
						}
					}
				}
			})
		},
		linkmanChange () {
			this.ruleForm.linkman = this.ruleForm.linkman.replace(this.linkmanReg, '')
		},
		load () {
			return new Promise((resolve, reject) => {
				var url = 'https://webapi.amap.com/maps?v=1.4.14&key=4840e0d822c880f0d785c9a2fa5b9d57'
				var script = document.createElement('script')
				script.charset = 'utf-8'
				script.src = url
				script.async = true
				script.defer = true
				script.type = 'text/javascript'
				document.head.appendChild(script)
				script.onload = () => {
					setTimeout(() => {
						_AMap = window.AMap
						_AMap.plugin(['AMap.Autocomplete'], (res) => {
							this.initSearchInput()
						})
						resolve('suc')
					}, 0)
				}
			})
		},
		initSearchInput () {
			this.autoInput = new _AMap.Autocomplete({
				input: 'searchInput',
				city: '全国',
				citylimit: true,
				datatype: 'poi'
			})
			this.autoInput.on('select', (ev) => {
				this.ruleForm.address = ev.poi.name
				this.locationLng = ev.poi.location.lng
				this.locationLat = ev.poi.location.lat
				this.$refs['ruleForm'].validateField('address', (error) => {
					if (!error) {
						return true
					} else {
						return false
					}
				})
			})
		},
		addressInput (value) {
			this.locationLat = ''
		},
		areaChange (formName) {
			if (this.ruleForm.area === '') {
				this.waringArea = true
			} else {
				this.waringArea = false
			}
			this.$refs[formName].validateField('area', (error) => {
				if (!error) {
					return true
				} else {
					return false
				}
			})
			this.ruleForm.city = ''
			this.ruleForm.province = ''
			this.provinceList = []
			this.cityList = []
			let a = this.provinceListTotal
			for (let i = 0; i < a.length; i++) {
				if (a[i].areacode === this.ruleForm.area) {
					this.provinceList.push(a[i])
				}
			}
		},
		provinceChange (data) {
			this.cityList = []
			this.ruleForm.city = ''
			let a = cityData.RECORDS
			for (let i = 0; i < a.length; i++) {
				if (this.ruleForm.province === a[i].pid) {
					this.cityList.push(a[i])
				}
			}
			this.postionChange(data)
		},
		cityChange (value) {
			// this.autoInput.setCity(this.ruleForm.city)
			this.postionChange('ruleForm')
		},
		postionChange (formName) {
			if (this.ruleForm.province === '' || this.ruleForm.city === '') {
				this.isTrue = true
			} else {
				this.isTrue = false
			}
			this.$refs[formName].validateField('postion', (error) => {
				if (!error) {
					console.log('OK')
				} else {
					return false
				}
			})
		},
		// businessHoursChange () {
		// 	if (this.ruleForm.businessHours === 'false') {
		// 		this.$nextTick(() => {
		// 			this.customTimeFlag = true
		// 		})
		// 	} else {
		// 		this.$nextTick(() => {
		// 			this.customTimeFlag = false
		// 			this.ruleForm.samedayDeliveryTime = ''
		// 		})
		// 	}
		// },
		cancel () {
			this.$refs.bannerUpload.returnSrc()
			if (this.sessionStoreId) {
				this.cityList = []
				this.shopid = this.sessionStoreId
				this.getDetailPost()
			} else {
				this.$refs.ruleForm.resetFields()
				this.ruleForm.province = ''
				this.ruleForm.city = ''
				this.provinceList = []
				this.cityList = []
				// this.customTimeFlag = true
				// this.ruleForm.closeTime = '23:59'
				// this.ruleForm.arrivaDate = '0'
				// this.ruleForm.arrivaTime = '23:59'
				// this.ruleForm.planDeliveryDay = '1'
				// this.ruleForm.planDeliveryTime = '23:59'
			}
		},
		getFormData (data) {
			this.imgData = data
		},
		updateImg (data) {
			this.type = data.type
		},
		isFalse (data) {
			if (data === true) {
				this.$message.error('请上传图片')
			} else {
				this.$refs['ruleForm'].resetFields()
			}
		},
		saveInfo () {
			console.log(this.imgData)
			if (this.ruleForm.area === '') {
				this.waringArea = true
			} else {
				this.waringArea = false
			}
			if (this.ruleForm.addressQuantityType === 'true') {
				if (this.ruleForm.addressQuantity === '') {
					this.$message.error('买家收货地址数量不能为空')
					return false
				}
			}
			if (this.ruleForm.province === '' || this.ruleForm.city === '') {
				this.isTrue = true
			} else {
				this.isTrue = false
			}
			this.$refs['ruleForm'].validate((valid) => {
				if (valid) {
					// this.$refs.bannerUpload.uploadImgHandler()
					this.save(this.imgData)
				} else {
					return false
				}
			})
		},
		save (data) {
			const params = {
				shopid: this.shopid,
				paymode: this.paymode,
				uploadInfo: this.type === 'add' ? {
					extension: data.extension ? data.extension : '',
					sourcepath: data.newUrl ? data.newUrl : '',
					deletePath: data.oldUrl ? data.oldUrl : ''
				} : null,
				name: this.ruleForm.storeName,
				tel: this.ruleForm.tel,
				otherTel: this.ruleForm.otherTel,
				linkman: this.ruleForm.linkman,
				email: this.ruleForm.email,
				area: this.ruleForm.area,
				province: this.ruleForm.province,
				city: this.ruleForm.city,
				address: this.ruleForm.address,
				coordinate: `${this.locationLng},${this.locationLat}`,
				square: this.ruleForm.square,
				memo: this.ruleForm.memo,
				addressNum: this.ruleForm.addressQuantityType === 'false' ? -1 : this.ruleForm.addressQuantity,
				stopflag: this.ruleForm.storeStatus
			}
			// formData.append('arrDateFlagToNoBusiness', this.ruleForm.businessHours)
			// formData.append('nobussinessflag', this.ruleForm.nobussinessflag)
			// formData.append('sendtimeflag', this.ruleForm.sendtimeflag)
			// formData.append('closeTime', this.ruleForm.closeTime === null ? '' : this.ruleForm.closeTime)
			// formData.append('begintime', this.ruleForm.startTime === null ? '' : this.ruleForm.startTime)
			// formData.append('samedayDeliveryTime', this.ruleForm.samedayDeliveryTime === null ? '' : this.ruleForm.samedayDeliveryTime)

			// formData.append('groupcode', this.ruleForm.groupcode === null ? '' : this.ruleForm.groupcode)
			// formData.append('groupname', this.ruleForm.groupname === null ? '' : this.ruleForm.groupname)


			// formData.append('arrivaDate', +this.ruleForm.arrivaDate)
			// formData.append('arrivaTime', this.ruleForm.arrivaTime === null ? '' : this.ruleForm.arrivaTime)
			// formData.append('arriveDateToNoBusiness', +this.ruleForm.planDeliveryDay)
			// formData.append('arriveTimeToNoBusiness', this.ruleForm.planDeliveryTime === null ? '' : this.ruleForm.planDeliveryTime)
			// formData.append('stopflag', this.ruleForm.storeStatus)
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/get/addOrUpdate`,
				data: params
			}).then(res => {
				if (res.result) {
					this.$message.success('保存成功！')
					window.sessionStorage.setItem('storeid', res.data.id)
					this.shopid = res.data.id
					this.ruleForm.shopState = res.data.shopState
					this.getDetailPost()
				} else {
					this.$message.error(res.msg)
				}
			})
		},
		getDetailPost () {
			this.provinceList = []
			this.cityList = []
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/getDetailInfo/${this.shopid}`
			}).then(res => {
				if (res.result) {
					// this.takeDeliveryTimeFlag = res.data.takeDeliveryTimeFlag
					this.type = ''
					this.datasource = res.data.datasource
					this.clddock = res.data.clddock
					let data = res.data.shop
					this.shopid = res.data.id
					this.paymode = res.data.shop.paymode
					this.mdstopflag = data.mdstopflag
					this.sourceflag = data.sourceflag
					this.mdname = data.mdname
					if (data.addressNum === -1 || !data.addressNum) {
						this.ruleForm.addressQuantityType = 'false'
						this.ruleForm.addressQuantity = ''
					} else {
						this.ruleForm.addressQuantityType = 'true'
						this.ruleForm.addressQuantity = data.addressNum
					}
					this.mdcode = data.mdcode
					this.matchid = data.matchid
					window.sessionStorage.setItem('shopName', data.name)
					// this.ruleForm.groupname = data.groupname
					// this.ruleForm.groupcode = data.groupcode

					this.ruleForm.storeName = data.name
					this.ruleForm.storeName = data.name
					this.ruleForm.code = data.code
					this.ruleForm.imgurl = data.imgurl ? data.imgurl : ''
					this.ruleForm.tel = data.tel
					this.ruleForm.otherTel = data.otherTel
					this.ruleForm.linkman = data.linkman
					this.ruleForm.email = data.email
					this.ruleForm.area = data.area
					this.ruleForm.province = data.province
					this.ruleForm.city = data.city
					this.ruleForm.address = data.address
					this.ruleForm.square = data.square
					this.ruleForm.memo = data.memo
					// this.ruleForm.businessHours = '' + data.arrDateFlagToNoBusiness
					// this.customTimeFlag = !data.arrDateFlagToNoBusiness
					// this.ruleForm.startTime = data.begintime
					// console.log(data.samedayDeliveryTime)
					this.ruleForm.samedayDeliveryTime = data.samedaydeliverytime
					// this.ruleForm.sendtimeflag = data.sendtimeflag
					// this.ruleForm.nobussinessflag = data.nobussinessflag
					// this.ruleForm.closeTime = data.closeTime
					// this.ruleForm.arrivaDate = data.arrivaDate
					// this.ruleForm.arrivaTime = data.arrivaTime
					// this.ruleForm.planDeliveryDay = data.arriveDateToNoBusiness
					// this.ruleForm.planDeliveryTime = data.arriveTimeToNoBusiness
					this.ruleForm.storeStatus = '' + data.stopflag
					this.ruleForm.shopState = res.data.shopState
					this.locationLng = data.coordinate.split(',')[0]
					this.locationLat = data.coordinate.split(',')[1]
					this.provinceList = []
					// this.autoInput.setCity(data.city)
					if (this.ruleForm.tel !== '' && this.ruleForm.storeName !== '' && this.ruleForm.linkman !== '' && this.ruleForm.email !== '' && this.ruleForm.address !== '') {
						this.storeInfoFlag = true
					}
					let storeInfoFlag = JSON.stringify(this.storeInfoFlag)
					console.log(storeInfoFlag)
					window.sessionStorage.setItem('storeInfoFlag', storeInfoFlag)
					let b = this.provinceListTotal
					for (let i = 0; i < b.length; i++) {
						if (b[i].areacode === this.ruleForm.area) {
							this.provinceList.push(b[i])
						}
					}
					let a = cityData.RECORDS
					for (let i = 0; i < a.length; i++) {
						if (this.ruleForm.province === a[i].pid) {
							this.cityList.push(a[i])
						}
					}
					for (let a = 0; a < this.areaList.length; a++) {
						if (this.ruleForm.area === this.areaList[a].code) {
							this.area = this.areaList[a].name
						}
					}
					for (let a = 0; a < this.provinceList.length; a++) {
						if (this.ruleForm.province === this.provinceList[a].id) {
							this.province = this.provinceList[a].name
						}
					}
					for (let a = 0; a < this.cityList.length; a++) {
						if (this.ruleForm.city === this.cityList[a].id) {
							this.city = this.cityList[a].name
						}
					}
				}
			})
		}
	}
}
</script>

<style lang="stylus" scoped>
.store-info-body {
	display flex;
	height: 100%;
	min-height: 0;
	flex: 1;
	flex-direction column
	/deep/.el-form-item.is-success .el-input__inner {
		border-color: #DCDFE6
	}
	.store-info-container {
		display flex;
		flex: 1;
		overflow-y: auto;
		flex-direction column;
		.title-span{
			margin-left:20px
			font-weight 600
		}
		.store-picture{
			text-align:center;
			width :200px;
			height :200px;
			margin-left :100px
			.img-tips {
				color: #ababab
				padding: 10px 0
			}
		}
		.form-box {
			display flex
			flex-direction column
			text-align left
			.short-input {
				width: 200px
			}
			.tel-box {
				display flex
				flex-direction row
				min-height: 51px
				/deep/.el-input__inner {
					line-height: 10px
				}
				.el-form-item {
					&:nth-of-type(2) {
						/deep/.el-form-item__content {
							margin-left 20px!important
						}
					}
				}
				/deep/.el-form-item__error {
					top: 90%!important
				}
			}
			.select-input {
				&:nth-of-type(2) {
					margin-left: 20px
				}
			}
			.long-input {
				width: 420px
			}
		}
		.time-management {
			width: 100%
			border-top: 1px solid #dce2fd
			margin: 10px 0
			.time-choise {
				display flex
				margin-bottom: 10px
				.el-form-item {
					margin-right: 20px
				}
				.open-date {
					margin-bottom 0
				}
				span {
					display inline-block
					width 40px
					height: 28px
					line-height: 28px
					text-align center
				}
				.time-picker-part {
					width: 140px
				}
				/deep/.el-icon-time {
					height: 28px
				}
			}
			.delivery-time-box {
				font-size 14px
				padding-left: 28px
				margin-bottom: 10px
				/deep/.el-input__inner {
					height: 30px
					line-height: 10px;
				}
				span {
					display inline-block
					width: 170px
					text-align: justify
					text-align-last: justify
				}
				.delivery-time-input {
					width: 100px
					margin 0 10px
				}
			}
		}
		.store-setting {
			width: 100%
			border-top: 1px solid #dce2fd
			.open-status {
				font-size 14px
				padding-left: 28px
			}
		}
	}
	.store-info-btn {
		box-sizing: border-box;
		height:80px;
		text-align left
		padding: 20px 0
		.btn {
			width :130px;
			height :35px;
			margin-left :20px;
		}
	}
	.address-quantity {
		margin-top: 10px;
		/deep/.el-form-item__label {
			width: 180px!important;
		}
	}
}
</style>
